<template>
  <div class="home">
    <mb-header></mb-header>
    <div class="khk_logo" :style="{ minHeight: getClientHeight + 'px' }">
      <div class="khk_logo_img">
        <img src="../assets/khk001-logo_01.png" alt class="khk_logo_img_1" />
        <img
          src="../assets/khk001-logo_02.png"
          alt
          class="animated pulse khk_logo_img_2"
        />
        <img
          src="../assets/khk001-logo_03.png"
          alt
          :class="['scrollin', { khk_logo_img_3: scrollin }]"
        />
      </div>
      <swiper
        class="swiper-container-one"
        id="home"
        :style="{ height: getClientHeight + 'px' }"
      >
        <!-- slides -->
        <swiper-slide
          class="swiper-item"
          v-for="item of swiperList"
          :key="item.guid"
        >
          <img class="swiper-img" :src="item.show_image_address" alt />
        </swiper-slide>
      </swiper>
    </div>

    <div
      class="banner banner_one"
      id="introduction"
      :style="{ minHeight: getClientHeight + 'px' }"
    >
      <div class="main-contents">
        <img src="../assets/khk002a-block.png" alt="banner3" class="img" />
        <div class="info_content" id="info_content"></div>
        <img src="../assets/khk002a-pi.jpg" alt="khk002a-pi" class="pi" />
      </div>
    </div>
    <div
      class="banner_two banner"
      id="origin"
      :style="{ minHeight: getClientHeight + 'px' }"
    >
      <img src="../assets/khk002b-2.png" alt="banner4" class="khk002b_2_img" />
      <div class="swiperBox">
        <div id="swiper">
          <div class="imgBox">
            <div class="imgDiv" v-for="(item, index) of imgList" :key="index">
              <img :src="item" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="banner_three banner"
      id="products"
      :style="{ minHeight: getClientHeight + 'px' }"
    >
      <div class="box1" :style="{ minHeight: getClientHeight + 'px' }">
        <ul class="box_ul">
          <li>
            <router-link to="/products/1" target="_blank">
              <div class="ban_img">
                <img
                  src="../assets/003-1.png"
                  alt
                  class="prc_banner_img prc_banner_img_1"
                />
              </div>

              <div class="prc_info">
                <span>齿轮</span>
                <span>Gear</span>
              </div>
            </router-link>
          </li>
          <li>
            <router-link to="/products/8" target="_blank">
              <div class="ban_img">
                <img
                  src="../assets/003-2.png"
                  alt
                  class="prc_banner_img prc_banner_img_2"
                />
              </div>

              <div class="prc_info">
                <span>齿条</span>
                <span>Racks</span>
              </div>
            </router-link>
          </li>
          <li>
            <router-link to="/products/9" target="_blank">
              <div class="ban_img">
                <img
                  src="../assets/003-3.png"
                  alt
                  class="prc_banner_img prc_banner_img_3"
                />
              </div>

              <div class="prc_info">
                <span>CP齿条&齿轮</span>
                <span>CP Rack&Pinion</span>
              </div>
            </router-link>
          </li>
          <li>
            <router-link to="/products/10" target="_blank">
              <div class="ban_img">
                <img
                  src="../assets/003-4.png"
                  alt
                  class="prc_banner_img prc_banner_img_4"
                />
              </div>

              <div class="prc_info">
                <span>蜗杆蜗轮</span>
                <span>Worm Gear</span>
              </div>
            </router-link>
          </li>
          <li>
            <router-link to="/products/11" target="_blank">
              <div class="ban_img">
                <img
                  src="../assets/003-5.png"
                  alt
                  class="prc_banner_img prc_banner_img_5"
                />
              </div>

              <div class="prc_info">
                <span>齿轮箱</span>
                <span>Gears Boxes</span>
              </div>
            </router-link>
          </li>
          <li>
            <router-link to="/products/13" target="_blank">
              <div class="ban_img">
                <img
                  src="../assets/003-6.png"
                  alt
                  class="prc_banner_img prc_banner_img_6"
                />
              </div>

              <div class="prc_info">
                <span>其他产品</span>
                <span>Others</span>
              </div>
            </router-link>
          </li>
        </ul>
        <div class="tips">
          <h3>小原齿轮</h3>
          <div>
            <p>
              日本独立齿轮制造商，专业制造标准齿轮种类多达 300 个系列，3
              万种规格。
            </p>
            <p>
              正齿轮，锥齿轮，斜齿齿轮，交错轴齿轮，蜗轮蜗杆，齿轮箱，减速机齿轮，
            </p>
            <p>标准品常备库存，交期短，订货没有起订量限制!</p>
          </div>
        </div>
      </div>
    </div>
    <div
      class="banner_four banner"
      id="techCenter"
      :style="{ minHeight: getClientHeight + 'px' }"
    >
      <div class="box2" :style="{ minHeight: getClientHeight + 'px' }">
        <div class="box2_wrapper">
          <ul class="box_ul">
            <li>
              <router-link to="/techCenter/1" class="tech" target="_blank">
                <div class="prc_info">
                  <span>齿轮问答</span>
                  <span class="en">Q & A</span>
                </div>
                <img src="../assets/tech4.png" alt class="prc_img" />
              </router-link>
            </li>
            <li>
              <router-link to="/techCenter/2" class="tech" target="_blank">
                <div class="prc_info">
                  <span>图纸下载</span>
                  <span class="en">Download</span>
                </div>
                <img src="../assets/tech2.png" alt class="prc_img" />
              </router-link>
            </li>
            <li>
              <router-link to="/techCenter/3" class="tech" target="_blank">
                <div class="prc_info">
                  <span>计算公式</span>
                  <span class="en">Calculation</span>
                </div>
                <img src="../assets/tech3.png" alt class="prc_img active" />
              </router-link>
            </li>
            <li>
              <router-link to="/techCenter/4" class="tech" target="_blank">
                <div class="prc_info">
                  <span>齿轮应用</span>
                  <span class="en">Application</span>
                </div>
                <img src="../assets/tech1.png" alt class="prc_img" />
              </router-link>
            </li>
          </ul>
          <div class="news_box">
            <div class="news_box_header">
              <span class="left">
                齿轮知识
                <small> Gear Knowledge </small>
              </span>
              <span class="right"
                ><router-link to="/post/list">更多信息</router-link>
              </span>
            </div>
            <div class="news_box_wrapper">
              <router-link
                tag="div"
                class="news_box_content"
                v-for="(item, i) of NewsData"
                :key="i"
                :to="'/post/news/' + item.id"
              >
                <div class="news_item">
                  <div class="news_title">
                    {{ item.post_title }}
                  </div>
                  <div class="news_date">
                    {{ item.c_addition_date.split("T")[0] }}
                  </div>
                  <div class="news_txt">
                    {{ item.post_content }}
                  </div>
                </div>
              </router-link>
            </div>

            <!-- <div class="news_box_content">
              <div class="news_item">
                <div class="news_title">
                  新闻标题长度新闻标题长度新闻标题长度新闻标题长度
                </div>
                <div class="news_date">2022/04/30</div>
                <div class="news_txt">
                  新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正
                </div>
              </div>
            </div>
            <div class="news_box_content">
              <div class="news_item">
                <div class="news_title">
                  新闻标题长度新闻标题长度新闻标题长度新闻标题长度
                </div>
                <div class="news_date">2022/04/30</div>
                <div class="news_txt">
                  新闻正文内容新闻正文内容新闻正文内容新闻正文内容新闻正
                </div>
              </div>
            </div> -->
          </div>
          <router-link class="tech_center" to="/post/list">
            <img src="../assets/004-BA.png" alt="右侧按钮" srcset="" />
          </router-link>
        </div>

        <img src="../assets/khk004-ic.png" alt class="prc1_img" />
      </div>
    </div>
    <div
      class="banner_five banner"
      id="importExport"
      :style="{ minHeight: getClientHeight + 'px' }"
    >
      <div class="nav-img">
        <a href="https://sh-million.com/post/news/30"
          ><img class="nav-img-item nav-img-item-01" src="../assets/001.png"
        /></a>
        <a href="https://sh-million.com/post/news/26"
          ><img class="nav-img-item nav-img-item-02" src="../assets/002.png"
        /></a>
        <a href="https://sh-million.com/post/news/51"
          ><img class="nav-img-item nav-img-item-03" src="../assets/003.png"
        /></a>
        <a href="https://sh-million.com/post/news/31"
          ><img class="nav-img-item nav-img-item-04" src="../assets/004.png"
        /></a>
        <a href="https://sh-million.com/post/news/50"
          ><img class="nav-img-item nav-img-item-05" src="../assets/005.png"
        /></a>
        <a href="https://sh-million.com/post/news/49"
          ><img class="nav-img-item nav-img-item-06" src="../assets/006.png"
        /></a>
        <a href="https://sh-million.com/post/list"
          ><img class="nav-img-item nav-img-item-07" src="../assets/007.png"
        /></a>
        <a href="https://sh-million.com/products/1"
          ><img class="nav-img-item nav-img-item-08" src="../assets/008.png"
        /></a>
        <a href="https://sh-million.com/techCenter/2"
          ><img class="nav-img-item nav-img-item-09" src="../assets/009.png"
        /></a>
        <a href="https://sh-million.com/techCenter/1"
          ><img class="nav-img-item nav-img-item-10" src="../assets/010.png"
        /></a>
        <a href="https://sh-million.com/contentUS"
          ><img class="nav-img-item nav-img-item-11" src="../assets/011.png"
        /></a>
      </div>
    </div>
    <div
      class="banner4 banner"
      id="partner"
      :style="{ minHeight: getClientHeight + 'px' }"
    >
      <swiper
        :options="swiperOption"
        class="swiper-container"
        id="home"
        :style="{ height: 350 + 'px' }"
      >
        <!-- slides -->
        <swiper-slide
          class="swiper-item"
          v-for="item of swiperList1"
          :key="item.id"
        >
          <a href="#home">
            <img class="swiper-img" :src="item.imgUrl" alt="1" />
          </a>
        </swiper-slide>
      </swiper>
      <div class="box2" :style="{ height: getClientHeight - 350 + 'px' }">
        <div class="left">
          <img src="../assets/par3.png" alt />
          <p>JQA-QMA14416</p>
          <p>JQA-EM6717</p>
        </div>
        <!-- <router-link to="/partner" target="_blank"> -->
        <div class="a">
          <div class="mid">
            <img src="../assets/par2.png" alt />
            <div>
              <p>
                小原齿轮（KHK齿轮）自创业以来经历了80余年，一直专注于齿轮制造。
                KHK凭借训练有素的员工、先进的生产设备、长年积累的生产诀窍及不断的改善活动，使KHK小原齿轮工业建立起了一整套能够满足当今世界不同客户需求的完整生产体系。
              </p>
              <p>
                KHK标准齿轮多达3万种，在销售方面，小原齿轮工业通过专业的代理店在世界各地提供区域性服务，通过KHK广泛的销售网络，将价格合理的小原齿轮产品安全迅速地送到客户手中。
              </p>
              <p>
                “提供信赖和满足” 是KHK小原齿轮工业的座右铭。
                小原齿轮全体员工将一如既往齐心协力，为能提供满足客户需求的产品不断努力。
              </p>
            </div>
            <router-link to="/partner" target="_blank">
              <div class="btn">了解更多</div>
            </router-link>
          </div>
          <div class="right">
            <img src="../assets/par1.png" alt />
          </div>
        </div>
      </div>
    </div>
    <div
      class="banner5 banner"
      id="aboutUs"
      :style="{ minHeight: getClientHeight + 'px' }"
    >
      <!-- <div class="about" :style="{ minHeight: getClientHeight +'px'}"> -->
      <div
        class="banner_wrapper"
        :style="{ minHeight: getClientHeight - 146 + 'px' }"
      >
        <div class="about">
          <router-link to="/" class="pantner" target="_blank">
            <img
              src="../assets/mail-a.png"
              alt
              v-if="!isShowAdvantage"
              @mouseenter="showAdvantage"
              class="img_1"
            />
            <img
              src="../assets/mail-a01.png"
              alt
              v-if="isShowAdvantage"
              class="img_2"
              @mouseleave="hideAnvantage"
            />
          </router-link>
          <router-link to="/contentUS" class="content" target="_blank">
            <img
              src="../assets/mail-b.png"
              alt
              v-if="!isShowContent"
              @mouseenter="showContent"
              class="img_1"
            />
            <img
              src="../assets/mail-b01.png"
              alt
              v-if="isShowContent"
              class="img_2"
              @mouseleave="hideContent"
            />
          </router-link>
        </div>
        <div class="web-menu">
          <div
            class="web-menu-item"
            v-for="(goup_item, i) of menuData"
            :key="i"
          >
            <div class="web-menu-first">{{ goup_item.menu_group_name }}</div>
            <div class="web-menu-sub-item">
              <div
                class="web-menu-sub"
                v-for="(sub_item, ik) of goup_item.sub_menu"
                :key="ik"
              >
                <a :href="sub_item.menu_link"> {{ sub_item.menu_name }} </a>
              </div>
            </div>
          </div>
          <!-- <div class="web-menu-item">
            <div class="web-menu-first">战略合作伙伴</div>
            <div class="web-menu-sub-item">
              <div class="web-menu-sub">
                <a href="">川口工厂</a>
              </div>
              <div class="web-menu-sub"><a href="">野田工厂</a></div>
              <div class="web-menu-sub"><a href="">野田第二工厂</a></div>
            </div>
          </div>

          <div class="web-menu-item">
            <div class="web-menu-first">关于齿轮</div>
            <div class="web-menu-sub-item">
              <div class="web-menu-sub"><a href="">侧隙问题</a></div>
              <div class="web-menu-sub"><a href="">强度问题</a></div>
              <div class="web-menu-sub"><a href="">齿轮应用</a></div>
            </div>
          </div>

          <div class="web-menu-item">
            <div class="web-menu-first">产品中心</div>
            <div class="web-menu-sub-item">
              <div class="web-menu-sub"><a href="">KHK 齿轮</a></div>
              <div class="web-menu-sub"><a href="">KHK 齿条</a></div>
              <div class="web-menu-sub"><a href="">涡轮蜗杆</a></div>
              <div class="web-menu-sub"><a href="">其他产品</a></div>
            </div>
          </div>

          <div class="web-menu-item">
            <div class="web-menu-first">服务与支持</div>
            <div class="web-menu-sub-item">
              <div class="web-menu-sub"><a href="">3D 图纸下载</a></div>
              <div class="web-menu-sub"><a href="">计算公式</a></div>
              <div class="web-menu-sub"><a href="">样册索取</a></div>
            </div>
          </div>

          <div class="web-menu-item">
            <div class="web-menu-first">服务与支持</div>
            <div class="web-menu-sub-item">
              <div class="web-menu-sub"><a href="">3D 图纸下载</a></div>
              <div class="web-menu-sub"><a href="">计算公式</a></div>
              <div class="web-menu-sub"><a href="">样册索取</a></div>
            </div>
          </div> -->
        </div>
      </div>
      <mb-fotter></mb-fotter>
    </div>
  </div>
</template>

<script>
import request from "../server/request.js";
import mbHeader from "../components/mb-header.vue";
import mbFotter from "../components/mb-fotter.vue";
import { Swiper } from "vue-awesome-swiper";

export default {
  name: "home",
  data() {
    return {
      // productsBannerHover:
      isShowAdvantage: false,
      isShowContent: false,
      scrollin: false,
      swiperOption: {
        mousewheel: false,
        autoplay: true,
        speed: 1800,
        delay: 2000,
        loop: true,
        effect: "fade",
        obvserver: true,
        obvserverParents: true,
        fadeEffect: {
          crossFade: true,
        },
      },
      menuDataObj: {},
      menuData: [
        {
          id: 1,
          c_addition_date: "2022-06-22T06:29:21.000Z",
          c_addition_unix: 1655908161,
          c_is_delete: false,
          guid: "b50fa3f2-f237-11ec-bb0d-0242ac110003",
          menu_type: "1",
          menu_index: "100",
          menu_group_key: "A100",
          menu_group_name: "战略合作伙伴",
          menu_name: "战略合作伙伴",
          menu_link: "https://baidu.com",
          sub_menu: [
            {
              id: 8,
              c_addition_date: "2022-06-22T06:57:38.000Z",
              c_addition_unix: 1655909858,
              c_is_delete: false,
              guid: "a873bd3b-f23b-11ec-bb0d-0242ac110003",
              menu_type: "2",
              menu_index: "103",
              menu_group_key: "A100",
              menu_group_name: "战略合作伙伴",
              menu_name: "野田第二工厂",
              menu_link: "https://baidu.com",
            },
            {
              id: 7,
              c_addition_date: "2022-06-22T06:57:09.000Z",
              c_addition_unix: 1655909829,
              c_is_delete: false,
              guid: "971d8f0b-f23b-11ec-bb0d-0242ac110003",
              menu_type: "2",
              menu_index: "102",
              menu_group_key: "A100",
              menu_group_name: "战略合作伙伴",
              menu_name: "野田工厂",
              menu_link: "https://baidu.com",
            },
            {
              id: 6,
              c_addition_date: "2022-06-22T06:56:40.000Z",
              c_addition_unix: 1655909800,
              c_is_delete: false,
              guid: "85d2360e-f23b-11ec-bb0d-0242ac110003",
              menu_type: "2",
              menu_index: "101",
              menu_group_key: "A100",
              menu_group_name: "战略合作伙伴",
              menu_name: "川口工厂",
              menu_link: "https://baidu.com",
            },
            {
              id: 23,
              c_addition_date: "2022-06-26T03:35:34.000Z",
              c_addition_unix: 1656243334,
              c_is_delete: false,
              guid: "17b8d21e-f544-11ec-bb0d-0242ac110003",
              menu_type: "2",
              menu_index: "1",
              menu_group_key: "A100",
              menu_group_name: "战略合作伙伴",
              menu_name: "1",
              menu_link: "1",
            },
          ],
        },
        {
          id: 2,
          c_addition_date: "2022-06-22T06:29:54.000Z",
          c_addition_unix: 1655908194,
          c_is_delete: false,
          guid: "c89ae08a-f237-11ec-bb0d-0242ac110003",
          menu_type: "1",
          menu_index: "200",
          menu_group_key: "A200",
          menu_group_name: "关于齿轮",
          menu_name: "关于齿轮",
          menu_link: "https://baidu.com",
          sub_menu: [
            {
              id: 11,
              c_addition_date: "2022-06-22T06:59:17.000Z",
              c_addition_unix: 1655909957,
              c_is_delete: false,
              guid: "e37e1087-f23b-11ec-bb0d-0242ac110003",
              menu_type: "2",
              menu_index: "203",
              menu_group_key: "A200",
              menu_group_name: "关于齿轮",
              menu_name: "齿轮应用",
              menu_link: "https://baidu.com",
            },
            {
              id: 10,
              c_addition_date: "2022-06-22T06:58:41.000Z",
              c_addition_unix: 1655909921,
              c_is_delete: false,
              guid: "ce0a44a3-f23b-11ec-bb0d-0242ac110003",
              menu_type: "2",
              menu_index: "202",
              menu_group_key: "A200",
              menu_group_name: "关于齿轮",
              menu_name: "强度问题",
              menu_link: "https://baidu.com",
            },
            {
              id: 9,
              c_addition_date: "2022-06-22T06:58:11.000Z",
              c_addition_unix: 1655909891,
              c_is_delete: false,
              guid: "bbed06fd-f23b-11ec-bb0d-0242ac110003",
              menu_type: "2",
              menu_index: "201",
              menu_group_key: "A200",
              menu_group_name: "关于齿轮",
              menu_name: "侧隙问题",
              menu_link: "https://baidu.com",
            },
          ],
        },
        {
          id: 3,
          c_addition_date: "2022-06-22T06:31:47.000Z",
          c_addition_unix: 1655908307,
          c_is_delete: false,
          guid: "0c137a7f-f238-11ec-bb0d-0242ac110003",
          menu_type: "1",
          menu_index: "300",
          menu_group_key: "A300",
          menu_group_name: "产品中心",
          menu_name: "产品中心",
          menu_link: "https://baidu.com",
          sub_menu: [
            {
              id: 15,
              c_addition_date: "2022-06-22T07:01:25.000Z",
              c_addition_unix: 1655910085,
              c_is_delete: false,
              guid: "2fd37d82-f23c-11ec-bb0d-0242ac110003",
              menu_type: "2",
              menu_index: "304",
              menu_group_key: "A300",
              menu_group_name: "产品中心",
              menu_name: "其他产品",
              menu_link: "https://baidu.com",
            },
            {
              id: 14,
              c_addition_date: "2022-06-22T07:00:48.000Z",
              c_addition_unix: 1655910048,
              c_is_delete: false,
              guid: "19e1fba6-f23c-11ec-bb0d-0242ac110003",
              menu_type: "2",
              menu_index: "303",
              menu_group_key: "A300",
              menu_group_name: "产品中心",
              menu_name: "涡轮蜗杆",
              menu_link: "https://baidu.com",
            },
            {
              id: 13,
              c_addition_date: "2022-06-22T07:00:16.000Z",
              c_addition_unix: 1655910016,
              c_is_delete: false,
              guid: "06e53a71-f23c-11ec-bb0d-0242ac110003",
              menu_type: "2",
              menu_index: "302",
              menu_group_key: "A300",
              menu_group_name: "产品中心",
              menu_name: "KHK 齿条",
              menu_link: "https://baidu.com",
            },
            {
              id: 12,
              c_addition_date: "2022-06-22T07:00:03.000Z",
              c_addition_unix: 1655910003,
              c_is_delete: false,
              guid: "ff0f6529-f23b-11ec-bb0d-0242ac110003",
              menu_type: "2",
              menu_index: "301",
              menu_group_key: "A300",
              menu_group_name: "产品中心",
              menu_name: "KHK 齿轮",
              menu_link: "https://baidu.com",
            },
          ],
        },
        {
          id: 4,
          c_addition_date: "2022-06-22T06:32:24.000Z",
          c_addition_unix: 1655908344,
          c_is_delete: false,
          guid: "22459d5b-f238-11ec-bb0d-0242ac110003",
          menu_type: "1",
          menu_index: "400",
          menu_group_key: "A400",
          menu_group_name: "服务与支持",
          menu_name: "服务与支持",
          menu_link: "https://baidu.com",
          sub_menu: [
            {
              id: 18,
              c_addition_date: "2022-06-22T07:06:24.000Z",
              c_addition_unix: 1655910384,
              c_is_delete: false,
              guid: "e1b034ca-f23c-11ec-bb0d-0242ac110003",
              menu_type: "2",
              menu_index: "403",
              menu_group_key: "A400",
              menu_group_name: "服务与支持",
              menu_name: "样册索取",
              menu_link: "https://baidu.com",
            },
            {
              id: 17,
              c_addition_date: "2022-06-22T07:04:45.000Z",
              c_addition_unix: 1655910285,
              c_is_delete: false,
              guid: "a6b2618d-f23c-11ec-bb0d-0242ac110003",
              menu_type: "2",
              menu_index: "402",
              menu_group_key: "A400",
              menu_group_name: "服务与支持",
              menu_name: "计算公式",
              menu_link: "https://baidu.com",
            },
            {
              id: 16,
              c_addition_date: "2022-06-22T07:03:51.000Z",
              c_addition_unix: 1655910231,
              c_is_delete: false,
              guid: "86f3a401-f23c-11ec-bb0d-0242ac110003",
              menu_type: "2",
              menu_index: "401",
              menu_group_key: "A400",
              menu_group_name: "服务与支持",
              menu_name: "3D 图纸下载",
              menu_link: "https://baidu.com",
            },
          ],
        },
      ],
      NewsData: [],
      swiperList: [
        // {
        //     id: 2,
        //     imgUrl: require('../assets/khk001-2.jpg')
        // },
        // {
        //     id: 3,
        //     imgUrl: require('../assets/khk001-3.jpg')
        // },
        // {
        //     id: 1,
        //     imgUrl: require('../assets/khk001-1.jpg')
        // },
      ],
      imgList: [
        require("../assets/office (1).jpg"),
        require("../assets/office (2).jpg"),
        require("../assets/office (3).jpg"),
        require("../assets/office (4).jpg"),
        require("../assets/office (5).jpg"),
        require("../assets/office (6).jpg"),
        require("../assets/office (7).jpg"),
        require("../assets/office (8).jpg"),
        require("../assets/office (9).jpg"),
        require("../assets/office (10).jpg"),
        require("../assets/office (11).jpg"),
        require("../assets/office (12).jpg"),
        require("../assets/office (13).jpg"),
        require("../assets/office (14).jpg"),
        require("../assets/office (15).jpg"),
      ],
      timer: null,
      getClientHeight:
        document.documentElement.clientHeight || document.body.clientHeight,
      // productsList: [],
      swiperList1: [
        // {
        //   id: 2,
        //   imgUrl: require("../assets/s1.jpg"),
        // },
        // {
        //   id: 3,
        //   imgUrl: require("../assets/s2.jpg"),
        // },
        {
          id: 1,
          imgUrl: require("../assets/s3a.jpg"),
        },
      ],
    };
  },
  components: {
    mbHeader,
    mbFotter,
  },
  created() {
    document.title = "【小原齿轮】专营KHK齿轮│上海米仑机械设备有限公司【官网】";
    this.loadData();
    this.getShowImage();
  },
  mounted() {
    this.move();
    setTimeout(() => {
      this.scrollin = true;
    }, 2500);
  },
  watch: {
    getClientHeight: function () {
      window.onresize(() => {
        this.getClientHeight =
          document.documentElement.clientHeight || document.body.clientHeight;
      });
    },
  },
  methods: {
    initSwiper() {
      setTimeout(() => {
        new Swiper(".swiper-container-one", {
          autoplay: true,
          speed: 1800,
          delay: 2000,
          loop: true,
          effect: "fade",
          obvserver: true,
          obvserverParents: true,
          fadeEffect: {
            crossFade: true,
          },
          observer: true, // 启动动态检查器(OB/观众/观看者)
          observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        });
      }, 300);
    },
    getShowImage() {
      request.getShowImage((res) => {
        this.swiperList = res.data.filter(
          (item) => item.show_image_location == "khk001"
        );
        this.$nextTick(() => {
          this.initSwiper();
        });
      });
    },
    loadData() {
      request.getIntroductionContent((res) => {
        document.getElementById("info_content").innerHTML =
          res.data[0].copy_writing_content;
      });
      request.getWebMenu((res) => {
        if (res && res.length > 0) {
          const _menuData = res;
          const groupData = _menuData
            .filter((k) => k.menu_type == "1")
            .sort((a, b) => a.menu_index - b.menu_index);
          let groupDataObj = {};
          groupData.forEach((item) => {
            groupDataObj[item.menu_group_name] = item;
            groupDataObj[item.menu_group_name]["sub_menu"] = _menuData
              .filter(
                (k) =>
                  k.menu_type == "2" && k.menu_group_key == item.menu_group_key
              )
              .sort((a, b) => b.menu_index - a.menu_index);
          });
          this.menuData = Object.values(groupDataObj);
          // console.log(Object.values(groupDataObj));
          // this.menuuData = Object.values();
          // this.menuData = res.data;
        }
      });

      request.getNewsList((res) => {
        if (res && res.length > 0) {
          const _Data = res;
          this.NewsData = _Data;
          // console.log(Object.values(groupDataObj));
          // this.menuuData = Object.values();
          // this.menuData = res.data;
        }
      });
    },
    showAdvantage() {
      this.isShowAdvantage = true;
    },
    showContent() {
      this.isShowContent = true;
    },
    hideAnvantage() {
      this.isShowAdvantage = false;
    },
    hideContent() {
      this.isShowContent = false;
    },
    move() {
      let imgBox = document.getElementsByClassName("imgBox")[0];
      imgBox.innerHTML += imgBox.innerHTML;
      let imgDiv = document.getElementsByClassName("imgDiv");
      imgBox.style.width = imgDiv.length * this.imgWidth + "px";
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (imgBox.offsetLeft < -(imgBox.offsetWidth / 2 - 364)) {
          //向左滚动
          imgBox.style.left = 0;
        }
        imgBox.style.left = imgBox.offsetLeft + -Math.abs(1) + "px";
      }, 30);
    },
    beforeDestroy() {
      clearInterval(this.timer);
      this.timer = null;
    },
  },
};
</script>

<style lang="less" scoped>
.home {
  min-width: 1280px;
  height: 100vh;
  scroll-behavior: smooth;
  // overflow-y: scroll;
}
.khk_logo {
  position: relative;
  .khk_logo_img {
    position: absolute;
    top: 50%;
    left: 50%;
    display: flex;
    flex-direction: column;
    z-index: 11;
    margin-left: -390px;
    margin-top: -160px;
    img {
      width: 100%;
      height: 100%;
    }
    .khk_logo_img_2 {
      animation: pulse 1.5s ease-in-out 0.5s;
    }
    .scrollin {
      opacity: 0;
    }
    .scrollin.khk_logo_img_3 {
      transition: all 1s;
      opacity: 1;
    }
  }
}
.banner_one {
  background: url("../assets/khk002a.jpg") no-repeat center center fixed;
  background-size: cover;
  .main-contents {
    position: relative;
    .img {
      width: 90%;
      margin-left: 5%;
      margin-top: 6%;
    }
    .info_content {
      position: absolute;
      left: 12%;
      top: 50%;
      margin-top: -263px;
      padding-top: 8%;
      width: 36.7%;
      p {
        line-height: 1.8;
        font-size: 0.32rem;
        text-indent: 2em;
        font-weight: 400;
        margin: 0;
        margin-bottom: 0.3rem;
      }
    }
    .pi {
      position: absolute;
      right: 10%;
      top: 20%;
      width: 40%;
      height: auto;
    }
  }
}
.banner_two {
  background: url("../assets/khk002b-1.jpg") no-repeat center center fixed;
  background-size: cover;
  vertical-align: top;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  .khk002b_2_img {
    width: 55%;
    margin-bottom: -5%;
    margin-left: 28%;
    z-index: 10;
  }

  .swiperBox {
    width: 100%;
    height: 220px;
    #swiper {
      width: 100%;
      height: 100%;
      overflow: hidden;
      position: relative;
      .imgBox {
        position: absolute;
        left: 0;
        bottom: 0;
        overflow: hidden;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        .imgDiv {
          width: 300px;
          height: 220px;
          background-size: 100%;
          cursor: pointer;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
.banner_three {
  background: url("../assets/khk003.jpg") no-repeat center center fixed;
  background-size: cover;
  background-attachment: scroll;
  .box1 {
    display: flex;
    flex-direction: column;
    align-items: center;
    .box_ul {
      display: flex;
      flex-wrap: wrap;
      flex-flow: row wrap;
      justify-content: space-between;
      margin-top: 50px;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      margin: 0 auto;
      margin-top: 80px;
      li {
        display: flex;
        flex-direction: column;
        width: 615px;
        height: 358px;
        color: #fff;
        align-items: center;
        margin-top: 48px;
        cursor: pointer;
        a {
          color: #ff6400;
          width: 236px;
          position: relative;
          height: 236px;
          .ban_img {
            .prc_banner_img {
              position: absolute;
              top: 0;
              width: 100%;
              height: 100%;
            }

            .prc_banner_img_1:hover {
              content: url("../assets/003a-1.png");
            }

            .prc_banner_img_2:hover {
              content: url("../assets/003a-2.png");
            }
            .prc_banner_img_3:hover {
              content: url("../assets/003a-3.png");
            }
            .prc_banner_img_4:hover {
              content: url("../assets/003a-4.png");
            }
            .prc_banner_img_5:hover {
              content: url("../assets/003a-5.png");
            }
            .prc_banner_img_6:hover {
              content: url("../assets/003a-6.png");
            }
          }
        }

        .prc_info {
          display: flex;
          flex-direction: column;
          width: 100%;
          align-items: center;
          margin-top: 240px;
          span {
            font-size: 0.4rem;
            margin-top: 0.1rem;
            font-weight: 800;
          }
        }
      }
    }
    .tips {
      display: flex;
      align-items: center;
      flex-direction: column;
      color: #ff0012;
      font-size: 0.28rem;
      h3 {
        margin: 0;
        margin-bottom: 0.3rem;
      }
      p {
        text-align: center;
        margin: 0;
        margin-bottom: 0.1rem;
        font-weight: 800;
      }
    }
  }
}
.banner_four {
  background: url("../assets/khk004.jpg") no-repeat center center fixed;
  background-size: cover;
  .box2 {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    .box_ul {
      display: flex;
      flex-wrap: wrap;
      justify-content: left;
      // margin-top: 50px;
      width: 560px;
      height: 647px;
      align-content: space-between;
      li {
        display: flex;
        flex-direction: column;
        // width: 170px;
        // height: 222px;
        width: 246px;
        height: 315px;
        color: #fff;
        align-items: center;
        justify-content: center;
        // margin-top: 0.48rem;
        cursor: pointer;
        border: 3px solid #476adb;
        // margin-right: 1.1rem;
        margin-right: 18px;
        border-radius: 5px;
        background: rgba(255, 255, 255, 0.6);
        border: 2px solid rgba(5, 65, 131, 1);
        &:first-child {
          margin-left: 0;
        }
        &:last-child {
          margin-right: 0;
        }
        .tech {
          color: #054183;
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          .prc_img {
            margin-top: 0.3rem;
            margin-bottom: 0.3rem;
            &.active {
              margin-top: 0;
            }
          }

          .prc_info {
            display: flex;
            flex-direction: column;
            width: 100%;
            align-items: center;
            span {
              font-size: 0.48rem;
              margin-top: 0.34rem;
              font-weight: 800;
              &.en {
                font-size: 0.4rem;
              }
            }
          }
        }
      }
      li:hover {
        border: 3px solid rgb(214, 61, 59);
        div {
          color: rgb(214, 61, 59);
        }
      }
    }
    .box2_wrapper {
      display: flex;
      flex-flow: row nowrap;
      justify-items: center;
      margin-top: 50px;
      // height: 510px;
      // width: 593px;
      height: 647px;
      .news_box {
        width: 840px;
        // width: 517px;
        background-color: rgba(255, 255, 255, 0.7);
        border-radius: 2px;
        z-index: 16;
        height: 100%;
        display: flex;
        flex-direction: column;
        padding: 16px 24px;
        .news_box_header {
          color: rgba(0, 58, 126, 1);
          // font-size: 20px;
          text-align: left;
          white-space: nowrap;
          line-height: 47px;
          height: 33px;
          font-size: 24px;
          font-weight: 500;
          color: #003a7e;
          line-height: 33px;
          .left {
            float: left;
          }
          .right {
            // font-size: 18px;
            font-size: 16px;
            float: right;
            a {
              color: rgba(137, 37, 33, 1);
              // color: red;
              font-weight: 600;
              &:hover {
                color: rgba(137, 37, 33, 1);
                // color: red;
              }
            }
          }
        }
        .news_box_wrapper {
          height: 100%;
          overflow-y: hidden;
        }
        .news_box_content {
          border-top: 1px solid #0583c9;
          margin-top: 18px;
          font-size: 16px;
          padding-top: 18px;
          cursor: pointer;
          .news_item {
            color: #0583c9;
            line-height: 24px;
          }
          .news_title {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            height: 24px;
          }
          .news_date {
            color: #333;
            font-weight: 500;
          }
          .news_txt {
            color: #333;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            height: 24px;
          }
          &:hover {
            div {
              color: rgb(214, 61, 59);
            }
          }
        }
      }
      .tech_center {
        // width: 240px;
        margin-left: 53px;
        box-shadow: 0px 0px 10px 6px rgba(5, 47, 167, 0.35);
        > img {
          // width: 100%;
          height: 647px;
        }
        :hover {
          box-shadow: 0px 0px 10px 6px rgba(214, 61, 59, 0.35);
        }
        img:hover {
          content: url("../assets/004-BB.png");
        }
      }
    }
    .prc1_img {
      width: 90%;
    }
  }
}
.banner4 {
  .active_img {
    width: 100%;
    background-size: 100%;
    vertical-align: top;
  }
  .box2 {
    display: flex;
    background: #ecfcff;
    align-content: center;
    justify-content: center;
    padding: 5%;
    .left {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-right: 0.9rem;
      p {
        margin: 0;
        font-weight: 800;
        color: rgba(0, 0, 0, 1);
        font-size: 14px;
        margin-top: 0.1rem;
      }
    }
    .a {
      display: flex;
      color: #000;
      justify-content: center;
      align-items: center;
      .mid {
        width: 9.72rem;
        margin-right: 1.1rem;
        z-index: 999;
        p {
          font-weight: 450;
          font-size: 0.28rem;
          text-indent: 2em;
          line-height: 1.7;
          margin: 0;
          margin-top: 0.1rem;
        }
        .btn {
          width: 1.42rem;
          height: 0.48rem;
          background: #0583c9;
          color: #fff;
          float: right;
          line-height: 0.48rem;
          border-radius: 5px;
          text-align: center;
          font-size: 12px;
        }
      }
      .right {
        width: 354px;
        height: 242px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
.banner5 {
  background: url("../assets/khk007.jpg") no-repeat center center fixed;
  background-size: cover;
  .banner_wrapper {
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
  }
  .about {
    display: flex;
    align-items: center;
    padding-bottom: 1.2rem;
    justify-content: center;
    width: 100%;
    .pantner {
      cursor: pointer;
      width: 400px;
      margin-right: 5%;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .content {
      cursor: pointer;
      width: 400px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .web-menu {
    display: flex;
    flex-flow: row nowrap;
    width: 100%;
    justify-content: center;
    .web-menu-item {
      padding: 0 58px;
      .web-menu-first {
        color: rgb(176, 33, 37);
        font-weight: 500;
        line-height: 42px;
        // font-size: 27px;
        font-size: 24px;
        text-align: left;
      }
      .web-menu-sub-item {
        .web-menu-sub {
          color: #0583c9;
          // font-size: 21px;
          // font-size: 14px;
          font-size: 18px;
          line-height: 32px;
          cursor: pointer;
          &:hover {
            color: #b02125;
          }
          a {
            color: #0583c9;
          }
          a:hover {
            color: #b02125;
          }
        }
      }
    }
  }
  .fotter {
    margin-top: -3.6rem;
  }
}
.banner_five {
  // background: url("../assets/khk005.jpeg") no-repeat center center fixed;
  background: url("../assets/khk005v0814.png") no-repeat center center fixed;
  background-attachment: local;
  // background: url("../assets/khk005-1.jpeg") no-repeat center center fixed;
  background-size: cover;
  .nav-img {
    display: flex;
    flex-flow: row wrap;
    width: 1360px;
    justify-content: center;
    align-content: center;
    height: 100vh;
    padding-top: 30%;
    margin: 0 auto;
    img {
      padding-right: 20px;
      padding-bottom: 30px;
    }
  }
  .nav-img-item-01:hover {
    content: url("../assets/101.png");
  }
  .nav-img-item-02:hover {
    content: url("../assets/102.png");
  }
  .nav-img-item-03:hover {
    content: url("../assets/103.png");
  }
  .nav-img-item-04:hover {
    content: url("../assets/104.png");
  }
  .nav-img-item-05:hover {
    content: url("../assets/105.png");
  }
  .nav-img-item-06:hover {
    content: url("../assets/106.png");
  }
  .nav-img-item-07:hover {
    content: url("../assets/107.png");
  }
  .nav-img-item-08:hover {
    content: url("../assets/108.png");
  }
  .nav-img-item-09:hover {
    content: url("../assets/109.png");
  }
  .nav-img-item-10:hover {
    content: url("../assets/110.png");
  }
  .nav-img-item-11:hover {
    content: url("../assets/111.png");
  }
}
@keyframes changeImg {
  from {
    left: -100%;
  }
  100% {
    left: 200%;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }
  to {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}
@keyframes pulse {
  from {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
  50% {
    -webkit-transform: scale3d(1.2, 1.2, 1.2);
    transform: scale3d(1.2, 1.2, 1.2);
  }
  to {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
    opacity: 1;
  }
}

.swiper-container {
  .swiper-item {
    img {
      width: 100%;
      height: 100%;
      vertical-align: top;
      object-fit: cover;
    }
  }
}

@media screen and (max-width: 1480px) {
  .banner_two {
    .khk002b_2_img {
      margin-bottom: -1%;
      position: relative;
      z-index: 10;
      width: 60%;
    }
  }
}
</style>